import { useEmergencyBannerData } from './useEmergencyBannerData';

export function useEmergencyBannerHeight() {
    const { data } = useEmergencyBannerData();

    return data ? 28 : 0;
}
